import { concatUrl } from './base'
import { appRequest } from './request'
import { encrypt, sessionCache } from '@gyasset/shared/utils';

const loginUrl = concatUrl('/login')
export async function login (username, password) {
  password = encrypt.md5(password)
  const body = new FormData()
  body.append('username', username)
  body.append('password', password)
  const result = await appRequest(loginUrl, {
    method: 'POST',
    body
  })
  return result
}
export async function bindLogin (username, password, bind) {
  password = encrypt.md5(password)
  const body = new FormData()
  body.append('username', username)
  body.append('password', password)
  body.append('bind', bind)
  const result = await appRequest(loginUrl, {
    method: 'POST',
    body
  })
  return result
}

const loadUserUrl = concatUrl('/user')
export async function loadUser () {
  const result = await appRequest(loadUserUrl, {
    method: 'GET'
  })
  return result
}

const logoutUrl = concatUrl('/user/logout')
export async function logout () {
  const result = await appRequest(logoutUrl, {
    method: 'GET'
  })
  return result
}

export async function loginByToken (token) {
  const url = concatUrl(`/login/token/${token}`)
  const result = await appRequest(url, {
    method: 'POST'
  })
  return result
}
export async function getEncodeUserIdentify () {
  const url = concatUrl(`/login/getEncodeUserIdentify`)
  const result = await appRequest(url, {
    method: 'POST'
  })
  return result.verify
}

export async function checkUserValid (verify) {
  const url = concatUrl(`/login/checkUserValid`)
  const body = new FormData()
  body.append('verify', verify)
  const result = await appRequest(url, {
    method: 'POST',
    body
  })
  return result.success
}

export async function getFailCount (userName) {
  const body = new FormData()
  const getFailCountUrl = concatUrl(`login/getFailCount`)
  body.append('userName', userName)
  return appRequest(getFailCountUrl, {
    method: 'POST',
    body
  })
}

export async function queryUserMobile(username, password) {
  const body = new FormData()
  password = encrypt.md5(password)
  const queryUserMobileUrl = concatUrl(`login/findUserMobile`)
  body.append('username', username)
  body.append('password', password)
  return appRequest(queryUserMobileUrl, {
    method: 'POST',
    body
  })
}

export async function verifyIpAddress() {
  const verifyIpAddressUrl = concatUrl(`login/verifyIpAddress`)
  return appRequest(verifyIpAddressUrl,{
    method: 'POST'
  })
}

export async function informationGetMosaicId (username, password) {
  const result = await appRequest(concatUrl('/information/getMosaicId'), {
    method: 'GET',
  })
  return result
}

/**
 *查询用户上一次播放时间
 * @param clientId
 * @param fileId
 * @returns {Promise<*>}
 */
export async function getLastPlayTime({clientId, fileId}) {
  return appRequest(concatUrl(`information/getLastPlayTime`), {
    method: 'POST',
    body: JSON.stringify({clientId, fileId}),
    headers: {'Content-Type': 'application/json'}
  })
}

/**
 * 记录用户播放次数
 * @param clientId
 * @param fileId
 * @param startPlayTime
 * @returns {Promise<*>}
 */
export async function addPlayLog({clientId, fileId, startPlayTime}) {
  return appRequest(concatUrl(`information/addPlayLog`), {
    method: 'POST',
    body: JSON.stringify({clientId, fileId, startPlayTime}),
    headers: {'Content-Type': 'application/json'}
  })
}

/**
 * 更新用户观看的进度
 * @param playId
 * @param lastPlayTime
 * @returns {Promise<*>}
 */
export async function updatePlayLog({playId, lastPlayTime}) {
  return appRequest(concatUrl(`information/updatePlayLog`), {
    method: 'POST',
    body: JSON.stringify({playId, lastPlayTime}),
    headers: {'Content-Type': 'application/json'}
  })
}

// 机构客户是否初始密码登入 0否1是
export async function checkInitialPasswordLogin() {
  const data = await appRequest(concatUrl(`/user/checkInitialPasswordLogin`), {
    method: 'GET',
    headers: {'Content-Type': 'application/json'}
  })

  if (data.data === '1') sessionCache.set('isInitialPassword', true);
  return data;
}

// 是否勾选发送邮箱验证码
export async function checkEmailFlag() {
  const data = await appRequest(concatUrl(`/checkEmailFlag`), {
    method: 'GET',
  })

  return data;
}